import React from 'react';
import { CircleCheck, Info, Lightbulb, X } from 'lucide-react';

interface SimpleAlertProps {
  message: string;
  variant?: 'success' | 'error' | 'warning' | 'info';
}

const SimpleAlert: React.FC<SimpleAlertProps> = ({ message, variant = 'success' }) => {
  const styles = {
    success: 'bg-[rgba(146,222,113,0.08)] text-accent border-[rgba(146,222,113,0.2)]',
    error:   'bg-[rgba(239,68,68,0.08)] text-[#f87171] border-[rgba(239,68,68,0.2)]',
    warning: 'bg-[rgba(255,165,0,0.08)] text-[#ffa500] border-[rgba(255,165,0,0.2)]',
    info:    'bg-[rgba(96,165,250,0.08)] text-[#60a5fa] border-[rgba(96,165,250,0.2)]',
  };
  const icons = {
    success: <CircleCheck className="w-4 h-4 flex-shrink-0" />,
    error:   <X className="w-4 h-4 flex-shrink-0" />,
    warning: <Lightbulb className="w-4 h-4 flex-shrink-0" />,
    info:    <Info className="w-4 h-4 flex-shrink-0" />,
  };

  return (
    <div className={`flex items-center gap-3 border px-4 py-2.5 font-['Space_Mono'] text-[9px] uppercase tracking-[0.06em] ${styles[variant]}`} role="alert">
      {icons[variant]}
      <p>{message}</p>
    </div>
  );
};

export default SimpleAlert;
